export const LocalStorageDataModel = {
	EMAIL:'email',
    USER_NAME: "userName",
	USER_IP: 'userIp',
	PREVIOUS_URL: "PREVIOUS_URL",
	MACHINE_ID:'machineId',
    AUTH_TOKEN: "TaxmannAuthorization",
	MACHINE_ID_NEW:'machineId1',
	HOMEPAGE_FILTER_SELECTION: 'homepageFilterSelection',
	INTERNAL_REFRERRER_URL: 'internalReferrerUrl',
	CONTENT_TOKEN: "contenttoken",
	UTM_CAMPAIGN_NAME: "activeCampaign",
	UTM_CAMPAIGN_URL: "activeCampaignUrl",
	EXTRA_NETCORE_PAYLOAD: "extraNetCorePayload",
	ENDMILE_USER_DATA: "endmileUserData",
	ENDMILE_EVENTS_CID_NUMBER: "endmileEventsCidNumber",
	FESTIVAL_DEAL:'popup_expire_date',
}
